
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/TermsAndConditions",
      function () {
        return require("private-next-pages/article/TermsAndConditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/TermsAndConditions"])
      });
    }
  